/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIndustry = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 2v6.382l7-4v4l7-4V22H2V2zM6 4H4v16h16V7.618l-7 4v-4l-7 4zm5 9v6H5v-6zm8 0v6h-6v-6zM9 15H7v2h2zm8 0h-2v2h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgIndustry as Industry };
